module.exports = __webpack_public_path__ + "static/media/tv.fb114741.jpeg";